// Historical "blocked" statuses describe review work, never disabled actions.
export function groupTransportChecks(checklist) {
  const watched = item => item.status === 'warning' || !item.ready;
  return {
    blocked: [],
    watched: checklist.filter(watched),
    ready: checklist.filter(item => item.ready && !watched(item)),
  };
}
